import { ArrowBackIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Divider,
  Grid,
  GridItem,
  Heading,
  HStack,
  Link,
  Stack,
  Text,
  VStack
} from '@chakra-ui/react';
import { Global } from '@emotion/react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { WhiteLabelMenu } from '../../../components/navigation/WhiteLabelMenu';
import { ButtonDateRanger } from '../../../components/white-label/buttons/ButtonDateRanger';
import { CardQuantitative } from '../../../components/white-label/CardQuantitative';
import { DatePickerRangerUnlimited } from '../../../components/white-label/DatePickerRangerUnlimited';
import { SelectFilterSearchDate } from '../../../components/white-label/inputs/SelectFilterSearchDate';
import { SelectFilterSearchSite } from '../../../components/white-label/inputs/SelectFilterSearchSite';
import { TableAccumuledValue } from '../../../components/white-label/tables/TableAccumuledValue';
import { TableMidiaContent } from '../../../components/white-label/tables/TableMidiaContent';
import { TableSalesContent } from '../../../components/white-label/tables/TableSalesContent';
import { apiSensedia } from '../../../services/api-sensedia';
import { getDadosLogin, UserDataType } from '../../../utils/dados-login.util';
import { setDateToTheEndOfTheDay } from '../../../utils/date.util';

const apiWl = apiSensedia;

export const PainelVendasWhiteLabel = () => {
  const { idWebsite } = useParams();

  const [startDate, setStartDate] = useState(
    new Date(new Date().setDate(new Date().getDate() - 30)).toISOString()
  );

  const [endDate, setEndDate] = useState(new Date().toISOString());

  const [contentTable, setContentTable] = useState('');

  const [isOpenDatePicker, setIsOpenDatePicker] = useState(false);
  const [isChosenDate, setIsChosenDate] = useState(false);

  const [idSiteForSearch, setIdSiteForSearch] = useState(idWebsite);

  const [quantitativeAcess, setQuantitiveAcess] = useState(0);
  const [quantitativeEffetivedSales, setQuantitiveEffetivedSales] = useState(0);
  const [quantitativeUnfulfilledSales, setQuantitiveUnfulfilledSales] =
    useState(0);
  const [quantitativeAccumuledValues, setQuantitiveAccumuledValues] =
    useState(0);

  const [searchTerm, setSearchTerm] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingQuantitative, setIsLoadingQuantitative] = useState(false);

  const [dataForOptionsForSite, setDataForOptionsForSite] = useState([
    { option: '', value: '' }
  ]);

  const [dataTableMidia, setDataTableMidia] = useState([
    {
      source: '',
      total: 0
    }
  ]);

  const [dadosLogin, setDadosLogin] = useState<Partial<UserDataType>>({});

  const [dataTableSalesEffective, setDataTableSalesEffective] = useState([
    {
      nome_cliente: '',
      telefone_cliente: '',
      email_cliente: '',
      cpf_cliente: '',
      data_nascimento_cliente: '',
      nome_profissao_cliente: ''
    }
  ]);

  const [dataTableSalesUnfulfilledSales, setDataTableSalesUnfulfilledSales] =
    useState([
      {
        nome_cliente: '',
        telefone_cliente: '',
        email_cliente: '',
        cpf_cliente: '',
        data_nascimento_cliente: '',
        nome_profissao_cliente: ''
      }
    ]);

  const [dataTableAcummuled, setDataTableAccumuled] = useState([
    {
      nome_produto: '',
      nome_cliente: '',
      valor_premio: '',
      numero_proposta: 0,
      periodicidade_pagamento: '',
      meio_pagamento: '',
      created_at: '',
      situacao: ''
    }
  ]);

  const fetchDadosLogin = async () => {
    const dadosLogin = await getDadosLogin();
    setDadosLogin(dadosLogin);
  };

  useEffect(() => {
    fetchDadosLogin();
  }, []);

  const [newDataTableMidia, setNewDataTableMidia] = useState<any>();

  const [offset, setOffSet] = useState(0);
  const [limit, setLimit] = useState(10);
  const [current, setCurrent] = useState(1);

  const [totalSalesEffetive, setTotalSalesEffetive] = useState(0);
  const [totalSalesUnfulfilled, setTotalSalesUnfulfilled] = useState(0);
  const [totalAcummuled, setTotalAcummuled] = useState(0);

  const [nameSite, setNameSite] = useState('');
  const [periodDefault, setPeriodDefault] = useState('');

  const [ordencao, setOrdenacao] = useState({ campo: '', ordem: '' });

  const getWebsites = async () => {
    try {
      const resWebsites = await apiWl.get('/corretores/123/websites');

      const resWebsitesFinal = resWebsites.data.map((item: any, index: any) => {
        return { option: item.website_title, value: item.codigo };
      });

      setDataForOptionsForSite(resWebsitesFinal);
    } catch (error: any) {
      console.log(error);
    }
  };

  const getQuantitativeCards = async () => {
    setIsLoadingQuantitative(true);
    try {
      const resAcessos = await apiWl.get(
        `/metricas/websites/${idSiteForSearch}/acessos/quantidade?inicio=${startDate}&fim=${endDate}`
      );

      const resVendasEfetuadas = await apiWl.get(
        `/metricas/websites/${idSiteForSearch}/vendas/quantidade?efetuadas=true&inicio=${startDate}&fim=${endDate}`
      );

      const resInfetuadas = await apiWl.get(
        `/metricas/websites/${idSiteForSearch}/vendas/quantidade?efetuadas=false&inicio=${startDate}&fim=${endDate}`
      );

      const resAcumulados = await apiWl.get(
        `/metricas/websites/${idSiteForSearch}/vendas/valores-acumulados?inicio=${startDate}&fim=${endDate}`
      );

      setQuantitiveAcess(resAcessos.data.count);
      setQuantitiveEffetivedSales(resVendasEfetuadas.data.count);
      setQuantitiveUnfulfilledSales(resInfetuadas.data.count);
      setQuantitiveAccumuledValues(resAcumulados.data.value);
      setIsLoadingQuantitative(false);
    } catch (error: any) {
      console.log(error + 'esse erro que deu' + startDate);
    }
  };

  const getDataTableMidia = async (idWebsite: any) => {
    setIsLoading(true);
    try {
      const res = await apiWl.get(
        `/metricas/websites/${idWebsite}/acessos/origem?inicio=${startDate}&fim=${endDate}`
      );
      setDataTableMidia(res.data);
      setNewDataTableMidia(res.data);
      setIsLoading(false);
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleSearch = (
    valorBusca: string,
    event: 'change' | 'blur' | 'click'
  ) => {
    if (event == 'change' && valorBusca.length % 4 === 0) {
      // console.log('valor buscado', valorBusca);
      setSearchTerm(valorBusca);
    }

    if (
      event == 'blur' &&
      valorBusca.length > 0 &&
      valorBusca.length % 4 !== 0
    ) {
      // console.log('valor buscado', valorBusca);
      setSearchTerm(valorBusca);
    }

    if (event == 'click') {
      setSearchTerm(valorBusca);
    }
  };

  const handleOrder = (campo: string, ordem: string) => {
    console.log('ordenacao', campo, ordem);
    let campoOrdenacao = '';
    if (campo === 'produto') {
      campoOrdenacao = 'orderByProdName';
    }

    if (campo === 'premio') {
      campoOrdenacao = 'orderByPremio';
    }

    if (campo === 'data') {
      campoOrdenacao = 'orderByData';
    }

    if (campo === 'situacao') {
      campoOrdenacao = 'orderBySituacao';
    }

    setOrdenacao({ campo: campoOrdenacao, ordem: ordem });
  };

  useEffect(() => {
    // console.log('ativou useeffect', searchTerm);
    getDataTableSales(idSiteForSearch, true);
    getDataTableSales(idSiteForSearch, false);
  }, [searchTerm]);

  useEffect(() => {
    getDataTableSales(idSiteForSearch, true);
    getDataTableSales(idSiteForSearch, false);
  }, [ordencao]);

  const getDataTableSales = async (idWebsite: any, effetued: boolean) => {
    setIsLoading(true);

    const verfifLimit =
      contentTable === 'effective-sales'
        ? quantitativeEffetivedSales
        : contentTable === 'unfulfilled-sales'
        ? quantitativeUnfulfilledSales
        : quantitativeAccumuledValues;
    try {
      const path = `/metricas/websites/${idWebsite}/vendas?efetuadas=${effetued}&_offset=${offset}&_limit=${
        verfifLimit > limit ? limit : verfifLimit
      }&inicio=${startDate}&fim=${endDate}${
        searchTerm.length > 0 ? `&search=${searchTerm}` : ''
      }${
        ordencao.campo.length > 0 && ordencao.ordem.length > 0
          ? `&${ordencao.campo}=${ordencao.ordem}`
          : ''
      }`;

      const resFinal = await apiWl.get(path);

      if (resFinal.data.length === undefined) {
        effetued &&
          totalSalesEffetive === 0 &&
          setTotalSalesEffetive(resFinal.data._embedded._result.length);

        !effetued &&
          totalSalesUnfulfilled === 0 &&
          setTotalSalesUnfulfilled(resFinal.data._embedded._result.length);

        totalAcummuled === 0 &&
          effetued &&
          setTotalAcummuled(resFinal.data._embedded._result.length);

        effetued
          ? setDataTableSalesEffective(resFinal.data._embedded._result)
          : setDataTableSalesUnfulfilledSales(resFinal.data._embedded._result);
        effetued && setDataTableAccumuled(resFinal.data._embedded._result);

        setIsLoading(false);
      } else {
        effetued &&
          totalSalesEffetive === 0 &&
          setTotalSalesEffetive(resFinal.data.length);

        !effetued &&
          totalSalesUnfulfilled === 0 &&
          setTotalSalesUnfulfilled(resFinal.data.length);

        totalAcummuled === 0 &&
          effetued &&
          setTotalAcummuled(resFinal.data.length);

        effetued
          ? setDataTableSalesEffective(resFinal.data)
          : setDataTableSalesUnfulfilledSales(resFinal.data);
        effetued && setDataTableAccumuled(resFinal.data);

        setIsLoading(false);
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleAllDataTables = async (webSite: string) => {
    await getDataTableMidia(webSite);
    await getDataTableSales(webSite, true);
    await getDataTableSales(webSite, false);
  };

  const dateToday = setDateToTheEndOfTheDay(new Date());

  const day = dateToday.getDate();
  const month = dateToday.getMonth() + 1;
  const year = dateToday.getFullYear();

  const dateFinal = new Date(`${month.toString()} ${day} ${year}`);

  const objForCards = [
    {
      colorTag: '#C5E7C9',
      label: 'Quantidade  de acessos',
      number: quantitativeAcess,
      content: 'midia'
    },
    {
      colorTag: '#e1dfa7',
      label: 'Quantidade de vendas (efetivadas)',
      number: quantitativeEffetivedSales,
      content: 'effective-sales'
    },
    {
      colorTag: '#FACED2',
      label: 'Quantidade de vendas (não efetivadas)',
      number: quantitativeUnfulfilledSales,
      content: 'unfulfilled-sales'
    },
    {
      colorTag: '#D3DEED',
      label: 'Valores acumulados',
      number: quantitativeAccumuledValues,
      content: 'accumuled-values'
    }
  ];

  const dataForOptionsForSearch = [
    { option: ' últimos 15 dias', value: '15' },
    { option: ' últimos 30 dias', value: '30' },
    { option: ' últimos 6 meses', value: '180' },
    { option: ' últimos 12 meses', value: '365' }
  ];

  const dataOptionsForDataExport = [
    { type: 'pdf' },
    { type: 'csv' },
    { type: 'xlsx' }
  ];

  const handleClearSearch = () => {
    setStartDate(new Date().toISOString());
    setEndDate(
      new Date(new Date().setDate(new Date().getDate() + 15)).toISOString()
    );
    setIsOpenDatePicker(false);
    setIsChosenDate(false);
    setIdSiteForSearch('');
    setPeriodDefault('');
    setOffSet(0);
    setLimit(10);
  };

  const handleChangeSite = (site: any) => {
    setIdSiteForSearch(site);
    setOffSet(0);
  };

  const handleChangeDate = (date: string) => {
    setPeriodDefault(date);
    const dateForNDays = new Date(
      new Date().setDate(dateFinal.getDate() - Number(date))
    );
    const dateTodayFormat = dateToday.toISOString();
    const dateForNDaysFormat = dateForNDays.toISOString();

    setStartDate(dateForNDaysFormat);
    setEndDate(dateTodayFormat);
  };

  const handleNameSite = () => {
    const nameSite = dataForOptionsForSite.map((site) =>
      idSiteForSearch && site.value.includes(idSiteForSearch) ? site.option : ''
    );

    const nameSiteFinal = nameSite.filter((res) => res != '');
    setNameSite(nameSiteFinal.toString());
  };

  const handleChangeDatePeriod = (date: string) => {
    console.log(date);
    handleChangeDate(date);
    getDataTableSales(idSiteForSearch, true);
    getDataTableSales(idSiteForSearch, false);
  };

  const url_current = window.location.href.split('/');
  url_current.length = url_current.length - 2;
  const url_modificated = [...url_current, 'painel']
    .toString()
    .replaceAll(',', '/');

  useEffect(() => {
    getQuantitativeCards();
    handleNameSite();
    handleChangeDatePeriod('30');
  }, [idSiteForSearch]);

  useEffect(() => {
    getQuantitativeCards();
    getDataTableSales(idSiteForSearch, true);
    getDataTableSales(idSiteForSearch, false);
  }, [offset, startDate, endDate]);

  useEffect(() => {
    getWebsites();
  }, []);

  useEffect(() => {
    setOffSet(0);
    setLimit(10);
    idSiteForSearch && handleAllDataTables(idSiteForSearch);
  }, [contentTable]);

  return (
    <>
      <Global styles={`body { background-color: #F4F4F4; }`} />
      <Grid templateColumns="15vw calc( 84vw - 17px )">
        <GridItem>
          <WhiteLabelMenu />
        </GridItem>
        <GridItem>
          <Box p="40px 56px">
            <VStack borderBottom="1px solid #D2D2D2">
              <HStack
                width="100%"
                justifyContent="space-between"
                alignItems="start"
              >
                <VStack alignItems="start">
                  <Heading fontSize="2rem">Painel de vendas</Heading>

                  <Text fontSize="1rem">
                    Confira aqui as vendas relacionadas ao site &nbsp;
                    {nameSite}
                  </Text>
                </VStack>
              </HStack>
              <Stack
                w="100%"
                m="50px 0 30px 0 !important"
                display="flex"
                alignItems="start"
              >
                <Link
                  m="0 !important"
                  href={url_modificated}
                  fontSize="0.875rem"
                  fontWeight="700"
                  lineHeight="1rem"
                  textDecoration="underline !important"
                  color="#828282"
                  onClick={() => {
                    console.log();
                  }}
                  _hover={{ color: '#146CFA' }}
                  _active={{}}
                  _focus={{
                    '&:focus': {
                      boxShadow: 'none !important'
                    }
                  }}
                >
                  <ArrowBackIcon ml="12px" w="1.25rem" h="1.25rem" />
                  Voltar
                </Link>
              </Stack>
            </VStack>

            <Divider />
            <Stack
              m="30px 0 0 0 !important"
              bg="#FFFFFF"
              p="20px 30px 30px 30px"
              borderRadius="24px"
              boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
            >
              <Text
                color="#001E64"
                fontSize="1.25rem"
                fontWeight="700"
                lineHeight="2rem"
              >
                Filtrar
              </Text>
              <HStack m="0 !important" justifyContent="space-between">
                <HStack
                  m="0 !important"
                  display="flex"
                  gridGap="16px"
                  alignItems="center"
                >
                  <Box
                    m="10px 0 0 0  !important"
                    w="268px"
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                    gridGap="10px"
                  >
                    <Text
                      color="#1F1E1F"
                      fontSize="1rem"
                      fontWeight="400"
                      lineHeight="1.5rem"
                    >
                      Escolha as datas
                    </Text>
                    <ButtonDateRanger
                      setIsChosenDate={setIsChosenDate}
                      setIsOpenDatePicker={setIsOpenDatePicker}
                      startDate={startDate}
                      endDate={endDate}
                      isChosenDate={isChosenDate}
                    />
                  </Box>
                  <Box
                    m="10px 0 0 0  !important"
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                    gridGap="10px"
                  >
                    <Text visibility="hidden">...</Text>
                    <Text>ou</Text>
                  </Box>
                  <SelectFilterSearchDate
                    value={periodDefault}
                    label={'Escolha o período'}
                    options={dataForOptionsForSearch}
                    handleChange={handleChangeDatePeriod}
                    placeholder={'Escolher Período'}
                  />
                  {dadosLogin?.seller?.redirects_to?.path ? (
                    <></>
                  ) : (
                    <SelectFilterSearchSite
                      value={idSiteForSearch}
                      getDataTable={handleAllDataTables}
                      label={'Escolha qual site'}
                      options={dataForOptionsForSite}
                      handleChange={handleChangeSite}
                      placeholder={'Escolher Site'}
                    />
                  )}
                </HStack>
                <Stack>
                  <Box
                    m="10px 0 0 0 !important"
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                    gridGap="10px"
                  >
                    <Text visibility="hidden">...</Text>
                    <Button
                      w="174px"
                      h="48px"
                      p="13px 39px"
                      bg="#FF5000"
                      borderRadius="24px"
                      fontWeight="500"
                      fontSize="1rem"
                      line-height="1.375rem"
                      color="#FFFFFF"
                      onClick={handleClearSearch}
                      _hover={{}}
                      _active={{}}
                      _focus={{
                        '&:focus': {
                          boxShadow: 'none !important'
                        }
                      }}
                    >
                      Limpar filtros
                    </Button>
                  </Box>
                </Stack>
              </HStack>
            </Stack>
            <HStack w="100%" justifyContent="space-between">
              {idSiteForSearch &&
                objForCards.map((item: any, index: any) => {
                  return (
                    <CardQuantitative
                      key={index}
                      colorTag={item.colorTag}
                      label={item.label}
                      quantitative={item.number}
                      callContent={item.content}
                      setContent={setContentTable}
                      isLoadingQuantitative={isLoadingQuantitative}
                    />
                  );
                })}
            </HStack>

            <Stack
              w="100%"
              m="0 !important"
              display={contentTable === 'midia' ? 'block' : 'none'}
            >
              <TableMidiaContent
                quantitative={quantitativeAcess}
                label={'Quantidade de acessos | por link'}
                dataOptionsForDataExport={dataOptionsForDataExport}
                dataTable={dataTableMidia}
                setDataTable={setDataTableMidia}
                newDataTable={newDataTableMidia}
                setNewDataTable={setNewDataTableMidia}
                isLoading={isLoading}
              />
            </Stack>
            <Stack
              w="100%"
              m="0 !important"
              display={contentTable === 'effective-sales' ? 'block' : 'none'}
            >
              <TableSalesContent
                current={current}
                limit={limit}
                setLimit={setLimit}
                total={totalSalesEffetive}
                offset={offset}
                setOffset={setOffSet}
                quantitative={quantitativeEffetivedSales}
                label={'Base de clientes | vendas efetivadas'}
                dataOptionsForDataExport={dataOptionsForDataExport}
                dataTable={dataTableSalesEffective}
                handleSearch={handleSearch}
                searchBarValue={searchTerm}
                isLoading={isLoading}
                hiddenColumns={['Motivo']}
              />
            </Stack>
            <Stack
              w="100%"
              m="0 !important"
              display={contentTable === 'unfulfilled-sales' ? 'block' : 'none'}
            >
              <TableSalesContent
                current={current}
                limit={limit}
                setLimit={setLimit}
                total={totalSalesUnfulfilled}
                offset={offset}
                setOffset={setOffSet}
                quantitative={quantitativeUnfulfilledSales}
                label={'Base de clientes | vendas não efetivadas'}
                dataOptionsForDataExport={dataOptionsForDataExport}
                dataTable={dataTableSalesUnfulfilledSales}
                handleSearch={handleSearch}
                searchBarValue={searchTerm}
                isLoading={isLoading}
                hiddenColumns={['Proposta']}
              />
            </Stack>
            <Stack
              w="100%"
              m="0 !important"
              display={contentTable === 'accumuled-values' ? 'block' : 'none'}
            >
              <TableAccumuledValue
                current={current}
                limit={limit}
                setLimit={setLimit}
                total={totalAcummuled}
                offset={offset}
                setOffset={setOffSet}
                quantitative={quantitativeEffetivedSales}
                label={'Base de clientes | vendas efetivadas'}
                dataOptionsForDataExport={dataOptionsForDataExport}
                dataTable={dataTableAcummuled}
                handleSearch={handleSearch}
                searchBarValue={searchTerm}
                handleOrder={handleOrder}
                isLoading={isLoading}
              />
            </Stack>
          </Box>
        </GridItem>
      </Grid>
      {isOpenDatePicker && (
        <>
          <Box
            position="absolute"
            top="0px"
            left="0px"
            h="100vh !important"
            w="100%"
            background="transparent"
            onClick={() => setIsOpenDatePicker(!isOpenDatePicker)}
          />
          <DatePickerRangerUnlimited
            startDate={endDate}
            setStartDate={setStartDate}
            endDate={startDate}
            setEndDate={setEndDate}
            setIsOpenDatePicker={setIsOpenDatePicker}
            setIsChosenDate={setIsChosenDate}
          />
        </>
      )}
    </>
  );
};
